// 购物车抽屉
import React, { useState, useEffect } from 'react';
import { Drawer, Icon, Button, Divider, Loading, Menu, Popover } from '@ss/mtd-react3';
import { message } from '@ss/mtd-react'
import { IconfontIconList } from "@/components/iconfont-iconlist";
import urls from '@/urls';
import { fetchData, handleDownloadResourceWithName } from '@/utils';
import { deleteIconInLs, getIconsInLs, setIconsInLs } from "@/utils/index";
import './style.scss';
import { MemberType } from '@/utils/constant/member';
import { Resource_Type_Identifier } from "@/utils/constant/teamManagement";
import RepositoryOperateModal from "@/components/repository-operate-modal";
import { getUserInfo } from "@/utils/index";

const MenuItem = Menu.Item;

export const IconfontCart = ({ visible = false, afterClose = () => {} }) => {

    const [isVisible, setIsVisible] = useState(visible);
    const [iconListLoading, setIconListLoading] = useState(false)
    const [iconList, setIconList] = useState([])
    const [projectList, setProjectList] = useState([])
    const [projectListLoading, setProjectListLoading] = useState(false)
    const [showRepositoryOperateModal, setShowRepositoryOperateModal] = useState(false)
    const [selectedProjectId, setSelectedProjectId] = useState('')
    const [userId, setUserId] = useState('')

    // 获取个人图标库列表
    const getProjectList = async () => {
        const params = {
            resourceTypeIdentifier: Number(Resource_Type_Identifier.ICON_REPOSITORY),
            memberType: MemberType.PERSON
        }

        setProjectListLoading(true)
        try {
            const res = await fetchData(urls.teamManage.getResourceList, params);
            const { list } = res;
            setProjectList(list)
        } catch (e) {
            message.error({
                message: 'Failed to obtain the list of personal icon libraries'
            })
            console.log(e)
        } finally {
            setProjectListLoading(false)
        }
    }

    useEffect(() => {
        const fetchIconList = async () => {
            const iconIdList = JSON.parse(localStorage.getItem('carts') || '[]');
            if (iconIdList.length !== 0) {
                try {
                    setIconListLoading(true);
                    const res = await fetchData(urls.iconfont.icon.getIconDetail, {
                        iconIdList: iconIdList.join(',')
                    });
                    if (res && Array.isArray(res)) {
                        const formattedIconList = res.map(item => {
                            return {
                                ...item,
                                iconCode: item.iconCode || item.code || '',
                                materialName: item.materialName || item.name || '',
                                materialId: item.materialId || item.id || '',
                            }
                        })
                        setIconList(formattedIconList);
                    }
                } catch (error) {
                    console.error(error);
                } finally {
                    setIconListLoading(false);
                }
            }
        };

        const initUserInfo = async () => {
            const userInfo = await getUserInfo();
            setUserId(userInfo.userId);
        }

        fetchIconList();
        getProjectList();
        initUserInfo();
    }, []);

    const handleVisibleChange = (visible) => {
        setIsVisible(visible);
        // afterClose && afterClose();
    }

    // 从购物车中删除单个图标
    const deleteFromCart = (materialId) => {
        const iconsInLocalStorage = getIconsInLs();
        if (iconsInLocalStorage.has(materialId)) {
            deleteIconInLs(materialId)
            setIconList(prevIconList => prevIconList.filter(item => item.materialId !== materialId));
        }
    }

    // 清空购物车
    const clearAllFromCart = () => {
        setIconsInLs(new Set())
        setIconList([])
    }

    // 下载购物车图标
    const downloadIconFromCart = async (type) => {
        if (!iconList || iconList.length === 0) {
            return
        }
        try {
            handleDownloadResourceWithName(`${urls.iconfont.icon.batchDownloadIcon.url}?${new URLSearchParams({
                iconIds: iconList.map(item => item.materialId),
                type
            }).toString()}`)
        } catch (error) {
            console.log(error)
        }
    }

    const handleSelectProjectChange = (key) => {
        setSelectedProjectId(key)
    }

    const handleConfirmAddProject = async () => {
        if(!selectedProjectId || selectedProjectId.trim() === ''){
            message.error({
                message: 'Please select the target icon library'
            })
            return
        }
        if(!iconList || iconList.length === 0){
            message.error({
                message: 'Please add the icon first'
            })
            return
        }
        try{
            const res = await fetchData(urls.iconfont.repository.addIconsToProject, {
                iconIds: iconList.map(item => item.materialId),
                projectId: Number(selectedProjectId)
            })
            if(res && res.success){
                message.success({
                    message: 'The icon was added successfully.'
                })
                clearAllFromCart()
            }else{
                message.info({
                    message: res.message || 'An anomaly occurred when adding the icon'
                })
            }
            handleVisibleChange(false)
        }catch(e){
            message.error({
                message: 'Failed to add the icon'
            })
        }
    }

    const renderProjectList = () => {
        return (
            <div className="project-list-content-wrapper">
                <div className="project-list-content">
                    <Menu inlineBaseIndent={8} className="project-list-content-menu" selectedKeys={selectedProjectId} onSelectChange={handleSelectProjectChange}>
                        {
                            projectList.map(item => {
                                return <MenuItem key={item.materialId}>{item.materialName}</MenuItem>
                            })
                        }
                    </Menu>
                </div>
                <div className="project-list-footer">
                    <Button type="grey" size="small" className="project-list-footer-btn" onClick={() => { setSelectedProjectId('') }}>取消</Button>
                    <Button type="primary" size="small" className="project-list-footer-btn" onClick={handleConfirmAddProject}>确定添加</Button>
                </div>
            </div>
        )
    }

    const renderAddProjectHeader = () => {
        return (
            <div className="project-list-header">
                <div className="project-list-header-title">添加至图标库</div>
                <div className="project-list-header-create" onClick={() => setShowRepositoryOperateModal(true)}>
                    <Icon type="add-square-o" />
                </div>
            </div>
        )
    }


    const btnDisabled = iconList.length === 0 || iconListLoading;
    return (
        <>
            <Drawer
                visible={isVisible}
                className="iconfont-cart-drawer"
                zIndex={300}
                title={
                    <div className="drawer-title-wrapper">
                        <div className="drawer-title-content">购物车({iconList.length})</div>
                        <div className="drawer-title-tool">
                            <div className="drawer-title-tool-item delete-all-icon" onClick={clearAllFromCart}>
                                <Icon type="delete-o" />
                                <span className="clear-all-text">一键清空</span>
                            </div>
                            <Divider className="drawer-title-divider" type="vertical" />
                        </div>
                    </div>
                }
                width={444}
                onClose={() => handleVisibleChange(false)}
                afterVisibleChange={(visibleState)=>{
                    if(!visibleState){
                        afterClose()
                    }
                }}>
                <div className="icon-list-wrapper">
                    {
                        iconListLoading ? <Loading direction="vertical" className="cart-loading-info" /> : <IconfontIconList
                            iconList={iconList}
                            scope="cart"
                            breakAfter={4}
                            emptyConfig={{
                                title: '',
                                description: '购物车里空无一物，赶快添加喜欢的图标吧',
                                className: 'cart-empty-info'
                            }}
                            onOperationFuncObj={{
                                onDelete: (id) => {
                                    deleteFromCart(id)
                                }
                            }}
                            autoCalculateMargin
                            overrideIconStyle={{
                                iconMarginRight: 12,
                                toolStyle: { top: 0, left: 0, height: 110, width: 90 }
                            }}
                        ></IconfontIconList>
                    }
                </div>
                <div className="icon-list-footer">
                    <Button disabled={btnDisabled} type="grey" onClick={() => downloadIconFromCart('font')} className="cart-drawer-btn">
                        下载代码
                    </Button>
                    <Button disabled={btnDisabled} type="grey" onClick={() => downloadIconFromCart('svg')} className="cart-drawer-btn">
                        下载素材
                    </Button>
                    <Popover title={renderAddProjectHeader} content={renderProjectList} trigger="click" placement="topRight" className="cart-drawer-popover">
                        <Button disabled={btnDisabled} type="primary" className="cart-drawer-btn">
                            添加至图标库
                        </Button>
                    </Popover>
                </div>
            </Drawer>
            {showRepositoryOperateModal && <RepositoryOperateModal
                isCreate={true}
                memberType={MemberType.PERSON}
                userId={userId}
                showModal={showRepositoryOperateModal}
                onModalClosed={() => setShowRepositoryOperateModal(false)}
                afterUpdate={getProjectList}
            />}
        </>
    );
}